function getServerURL() {
  const localhost = 'http://localhost:3123'
  const staging = 'https://pt-api.cloudxier.dev'
  const production = 'https://pt-api.isaacademy.co.id'

  let host = window.location.host;
  if (host) {
    host = host.toLowerCase();
  }

  let env
  switch (host) {
    case 'project-tracker.cloudxier.dev':
      env = staging
      break;
    case 'https://project-tracker.cloudxier.dev':
      env = staging
      break;
    case 'tracker.isaacademy.co.id':
      env = production
      break;
    case 'https://tracker.isaacademy.co.id':
      env = production
      break;
    default:
      env = localhost
  }
  return env
};

export default getServerURL
